'use client';

import { userStore, UserStore } from '@/lib/stores/user.store';
import { createContext, type ReactElement, type ReactNode } from 'react';

type RootStore = Readonly<{ userStore: UserStore }>;

const store: RootStore = { userStore };

export const StoreContext = createContext<RootStore>(store);

export default function StoreProvider({
  children,
}: Readonly<{ readonly children: ReactNode }>): ReactElement {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}
